import { Button, Snackbar, TextField } from "@material-ui/core";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSetRecoilState } from "recoil";
import { BASE_URL, sendData, sendFile } from "../../../../Models/Fetcher";
import { popupState, toastState } from "../../../../Store/atoms";
import { blurRoot, unBlurRoot } from "../../../../Utilities/DOMFunctions";
import SelectCustomer from "../../../TablesDisplay/SelectCustomer";

import "./styles.css";

export default () => {
  const setPopup = useSetRecoilState(popupState);
  const [file, setFile] = useState<null | File>(null);
  const [file3, setFile3] = useState<null | File>(null);
  const [customer, setCustomer] = useState(0);

  const setDisplayToast = useSetRecoilState(toastState);

  const { handleSubmit, control } = useForm();

  blurRoot();

  const handleUpload = async (data: any) => {
    const formData = new FormData();

    if (file !== null && file3 !== null) {
      formData.append("table2", file);
      formData.append("table3", file3);

      const response = await sendFile(
        BASE_URL +
          "upload" +
          "?customer=" +
          customer.toString() +
          "&name=" +
          data.tableName +
          "&description=" +
          data.description,
        formData
      );

      if (response.status !== 200) {
        setDisplayToast({
          open: true,
          severity: "error",
          message: response.data.message,
        });
      } else {
        setDisplayToast({
          open: true,
          severity: "success",
          message: response.data.message,
        });
      }
    }

    setPopup(null);
    unBlurRoot();
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.currentTarget;
    if (target.files) {
      setFile(target.files[0]);
    }
  };

  const onChangeType3 = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.currentTarget;
    if (target.files) {
      setFile3(target.files[0]);
    }
  };

  const onSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const target = event.target;
    setCustomer(+target.value);
  };

  return (
    <div className="upload-popup">
      <form className="upload-form" onSubmit={handleSubmit(handleUpload)}>
        <label className="upload-label">Type2 .csv file</label>
        <input
          type="file"
          id="file-input-2"
          name="fileType2"
          onChange={onChange}
        />
        <label className="upload-label">Type3 .csv file</label>
        <input
          type="file"
          id="file-input-3"
          name="fileType3"
          onChange={onChangeType3}
        />

        <SelectCustomer handleChange={onSelectChange} displayAll={false} />
        {/* <Controller
          name="customerName"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextField
              label="Customer name"
              value={value}
              onChange={onChange}
              error={!!error}
              helperText={error ? error.message : null}
              style={{ margin: "2rem 0 0.5rem 0 " }}
            />
          )}
          rules={{ required: "Name required" }}
        /> */}

        <Controller
          name="tableName"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextField
              label="Table name"
              value={value}
              onChange={onChange}
              error={!!error}
              helperText={error ? error.message : null}
              style={{ margin: "0.5rem 0 " }}
              fullWidth={true}
            />
          )}
          rules={{ required: "Name required" }}
        />

        <Controller
          name="description"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextField
              label="Description"
              value={value}
              onChange={onChange}
              error={!!error}
              helperText={error ? error.message : null}
              style={{ margin: "0.5rem 0 " }}
              fullWidth={true}
            />
          )}
          rules={{ required: "Description required" }}
        />
        <Button style={{ marginTop: "2rem" }} color="primary" type="submit">
          SUBMIT
        </Button>
      </form>
    </div>
  );
};
